// DetailFeatures — section 7. Canonical detail.html lines 571–589.
//
// RIC-3.0 — Feature.icon (backend) is now the authoritative icon source.
// `iconFor` prefers feature.icon; the legacy name→icon dictionary remains
// only as a graceful fallback for catalog rows whose icon has not been
// set in admin yet. Unknown / un-iconned features fall back to fa-tag.

const FEATURE_ICONS = {
  "Ліфт": "fa-solid fa-elevator",
  "Кондиціонер": "fa-solid fa-snowflake",
  "Камін": "fa-solid fa-fire",
  "Охорона": "fa-solid fa-shield-halved",
  "Дитячий майданчик": "fa-solid fa-children",
  "Підземний паркінг": "fa-solid fa-square-parking",
  "Меблі": "fa-solid fa-couch",
  "Центральне опалення": "fa-solid fa-temperature-arrow-up",
};

const iconFor = (feature) =>
  (feature && feature.icon) ||
  (feature && FEATURE_ICONS[feature.name]) ||
  "fa-solid fa-tag";

function DetailFeatures({ property }) {
  const features = (
    Array.isArray(property.features) ? property.features : []
  ).filter((feature) => feature && typeof feature === "object");

  return (
    <section className="detail-features">
      <div className="container">
        <div className="row">
          <h2 className="section-title">Особливості</h2>
          {features.length > 0 ? (
            <ul
              className="features-list"
              aria-label="Особливості та зручності"
            >
              {features.map((feature, index) => (
                <li key={feature.id ?? index} className="feature-chip">
                  <i className={iconFor(feature)} aria-hidden="true" />
                  {feature.name}
                </li>
              ))}
            </ul>
          ) : (
            <p>
              <span className="muted">—</span>
            </p>
          )}
        </div>
      </div>
    </section>
  );
}

export default DetailFeatures;
